import { FC, HTMLAttributes, useEffect, useRef } from "react";
import { GameCategory } from "../../components/common/GameCategory";
import { useStyles } from "./InstallGame.style";
import { useGamepadContext } from "../../contexts/GamepadProvider";
import { onGameListMoveAction } from "../../models/gamepad";
import { HeroBanner } from "../../components/common/HeroBanner";
import { useQuery } from "@apollo/client";
import { pageAaaGQL, Query } from "@onmo/graphql/graphql";
import { map } from "lodash-es";
import { isTV } from "../../utils/platform";
import { getMediaSizeScale } from "../../models/screen";

const InstallGame: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const contentRef = useRef<HTMLDivElement>(null);
  const { setCallback, cleanup } = useGamepadContext();
  const { data: pageData } = useQuery<Query>(pageAaaGQL, {
    variables: { input: { page: "byog" } },
  });

  const defaultCardWidth = isTV
    ? 320 * getMediaSizeScale()
    : undefined;

  useEffect(() => {
    setCallback({
      onMoveAction: onGameListMoveAction,
    });

    return () => {
      cleanup();
    };
  }, [cleanup, setCallback]);

  return (
    <div className={classes.root}>
      <div className={classes.rootContent} id="install-game">
        <HeroBanner type="install" />
        <div className={classes.content} ref={contentRef}>
          {map(pageData?.page?.items, (section) => (
            <GameCategory
              key={section?.id}
              section={section}
              isShowVideo={section?.group === "byog_videos"}
              defaultCardWidth={defaultCardWidth}
              isHideRating
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstallGame;
